export default __webpack_public_path__ + "static/media/Fury of Jovus.d8bfdef8.jpg";